import type {
  PermitRenewalPeriod,
  PermitVehicleScope,
  PermitZoneCoverageType,
  PermitTypeUsageFeeApplicability,
} from "common/types/permits";
import { convertDateToString } from "./time";

/** Format renewal period for display */
export function formatRenewalPeriod(period: PermitRenewalPeriod): string {
  const map: Record<PermitRenewalPeriod, string> = {
    annual: "Annual",
    monthly: "Monthly",
    quarterly: "Quarterly",
  };
  return map[period] || period;
}

/** Format vehicle scope for display */
export function formatVehicleScope(scope: PermitVehicleScope): string {
  const map: Record<PermitVehicleScope, string> = {
    per_vehicle: "Per Vehicle",
    per_account: "Per Account",
  };
  return map[scope] || scope;
}

/** Format zone coverage type for display */
export function formatZoneCoverageType(type: PermitZoneCoverageType): string {
  const map: Record<PermitZoneCoverageType, string> = {
    jurisdiction_wide: "Jurisdiction Wide",
    per_policy: "Per Policy",
  };
  return map[type] || type;
}

/** Format usage fee applicability for display. */
export function formatUsageFeeApplicability(applicability: PermitTypeUsageFeeApplicability): string {
  const map: Record<PermitTypeUsageFeeApplicability, string> = {
    always: "Permitted vehicles will be charged for use of zones.",
    sometimes: "Permitted vehicles may be charged for use of zones.",
    never: "Permitted vehicles will not be charged for use of zones.",
  };
  return map[applicability];
}

/** Format date for display, with fallback for null values */
export function formatPermitDate(dateString: string | null): string {
  if (!dateString) {
    return "Not set";
  }
  return convertDateToString(new Date(dateString));
}
